import React from "react";
import * as Phosphor from "@phosphor-icons/react";

// Renders a Phosphor icon by name with a safe fallback.
export function Icon({ name, weight = "duotone", className = "", size = 28 }) {
  const Cmp = Phosphor[name] || Phosphor.Circle;
  return <Cmp weight={weight} className={className} size={size} />;
}
